// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1ZUtj","sendOtp":"AuthorizeToLogin_sendOtp__1UuH0"};